'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loadable = require('UIComponents/decorators/Loadable');

var _Loadable2 = _interopRequireDefault(_Loadable);

var _ErrorState = require('../../components/ErrorState');

var _ErrorState2 = _interopRequireDefault(_ErrorState);

var _LoadingState = require('../../components/LoadingState');

var _LoadingState2 = _interopRequireDefault(_LoadingState);

var _resolveUnifiedThreadHistory = require('../resolvers/resolveUnifiedThreadHistory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AsyncUnifiedThreadView = (0, _Loadable2.default)({
  loader: _resolveUnifiedThreadHistory.resolveUnifiedThreadHistory,
  LoadingComponent: _LoadingState2.default,
  ErrorComponent: _ErrorState2.default
});

exports.default = AsyncUnifiedThreadView;
module.exports = exports['default'];